// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "root-2USIv";
var _4 = "type_review-1Y5YU";
var _5 = "online_check_in-1m_KV";
var _6 = "wait_payment-36srk";
var _7 = "confirmed-2O00q";
var _8 = "icon-1v8-V";
var _9 = "type_account-jsHGh";
var _a = "content-2RnGM";
var _b = "text-TcUq1";
var _c = "transactions_wrapper-2guB9";
var _d = "transactions-2_NGF";
var _e = "canceled-3rAto";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "root", _4 as "type_review", _5 as "online_check_in", _6 as "wait_payment", _7 as "confirmed", _8 as "icon", _9 as "type_account", _a as "content", _b as "text", _c as "transactions_wrapper", _d as "transactions", _e as "canceled" }
export default { "__esModule": _1, "tabletMiddle": _2, "root": _3, "type_review": _4, "online_check_in": _5, "wait_payment": _6, "confirmed": _7, "icon": _8, "type_account": _9, "content": _a, "text": _b, "transactions_wrapper": _c, "transactions": _d, "canceled": _e }
